import React, { Component } from "react";

import "./css/ShareMobile.css";

import BattenButton from "../interior/src/Button_Batten.png";
import FloorButton from "../interior/src/Button_Floor.png";
// import SheraImage from "../interior/src/Share.png";
// import ShopImage from "../interior/src/Shop.png";

import Axios from "axios";

const BattenLink = "https://www.shera.com/AR/api/?sqli=*&table=battens";
const FloorLink = "https://www.shera.com/AR/api/?sqli=*&table=floors";

export default class ShareMobile extends Component {
  state = {
    currentBatten: [],
    currentFloor: [],
    dataBatten: [],
    dataFloor: [],
  };

  async componentDidMount() {
    const batten = await Axios.get(BattenLink);
    this.setState({ dataBatten: batten.data });
    // console.log(batten.data);

    batten.data.map((resultBatten) => {
      if (resultBatten.id === this.props.currentBatten) {
        this.setState({ currentBatten: { ...resultBatten } });
      }
      return null;
    });

    const floor = await Axios.get(FloorLink);
    this.setState({ dataFloor: floor.data });
    // console.log(floor.data);

    floor.data.map((result) => {
      if (result.id === this.props.currentFloor) {
        this.setState({ currentFloor: { ...result } });
      }
      return null;
    });
  }

  render() {
    return (
      <>
        <div className="share-mobile-main">
          <div className="share-mobile-body">
            <img
              className="share-mobile-body-top-image"
              src={this.state.currentBatten.imagelink}
              alt=""
            />
            <img
              className="share-mobile-body-bottom-image"
              src={this.state.currentFloor.imagelink}
              alt=""
            />
          </div>

          <div className="resultScreen-mobile-info-container">
            <div className="resultScreen-mobile-info">
              <div className="resultScreen-mobile-info-header">
                <div>
                  <img
                    className="resultScreen-mobile-info-icon"
                    src={BattenButton}
                    alt=""
                  />
                </div>
                {/* <div className="resultScreen-mobile-info-button-container">
                <div className="resultScreen-mobile-info-button">
                  <img
                    className="resultScreen-mobile-info-button-image"
                    src={ShopImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-info-button-text">
                    ซื้อเลย
                  </div>
                </div>
              </div> */}
              </div>

              <div className="resultScreen-mobile-info-body">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-auto">
                      <img
                        className="resultScreen-mobile-info-body-icon"
                        src={this.state.currentBatten.iconlink}
                        alt=""
                      />
                    </div>
                    <div className="col">
                      <div className="row header-text">
                        {this.state.currentBatten.name}
                      </div>
                      <div className="row">
                        <table className="table table-borderless">
                          <thead style={{ backgroundColor: "#E6E7E8" }}>
                            <tr>
                              <th scope="col">รุ่น</th>
                              <th scope="col">ลาย</th>
                              <th scope="col">สี</th>
                              <th scope="col">
                                <div>ขนาด (ซม.)</div>
                                <div>(หนา * กว้าง * ยาว)</div>
                              </th>
                              <th scope="col">
                                <div>จำนวน</div>
                                <div>(แผ่น/ตร.ม.)</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ backgroundColor: "white" }}>
                            {this.state.dataBatten.map((data) =>
                              data.track === this.state.currentBatten.track ? (
                                <tr key={data.id}>
                                  <th scope="col">{data.class}</th>
                                  <th scope="col">{data.striped}</th>
                                  <th scope="col">{data.color}</th>
                                  <th scope="col">{data.size}</th>
                                  <th scope="col">{data.numpersqm}</th>
                                </tr>
                              ) : null
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="resultScreen-mobile-info">
              <div className="resultScreen-mobile-info-header">
                <img
                  className="resultScreen-mobile-info-icon"
                  src={FloorButton}
                  alt=""
                />
                {/* <div className="resultScreen-mobile-info-button-container">
                <div className="resultScreen-mobile-info-button">
                  <img
                    className="resultScreen-mobile-info-button-image"
                    src={ShopImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-info-button-text">
                    ซื้อเลย
                  </div>
                </div>
              </div> */}
              </div>
              <div className="resultScreen-mobile-info-body">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-auto">
                      <img
                        className="resultScreen-mobile-info-body-icon"
                        src={this.state.currentFloor.iconlink}
                        alt=""
                      />
                    </div>
                    <div className="col">
                      <div className="row header-text">
                        {this.state.currentFloor.name}
                      </div>
                      <div className="row">
                        <table className="table table-borderless">
                          <thead style={{ backgroundColor: "#E6E7E8" }}>
                            <tr>
                              <th scope="col">รุ่น</th>
                              <th scope="col">ลาย</th>
                              <th scope="col">สี</th>
                              <th scope="col">
                                <div>ขนาด (ซม.)</div>
                                <div>(หนา * กว้าง * ยาว)</div>
                              </th>
                              <th scope="col">
                                <div>จำนวน</div>
                                <div>(แผ่น/ตร.ม.)</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ backgroundColor: "white" }}>
                            {this.state.dataFloor.map((data) =>
                              data.track === this.state.currentFloor.track ? (
                                <tr key={data.id}>
                                  <th scope="col">{data.class}</th>
                                  <th scope="col">{data.striped}</th>
                                  <th scope="col">{data.color}</th>
                                  <th scope="col">{data.size}</th>
                                  <th scope="col">{data.numpersqm}</th>
                                </tr>
                              ) : null
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="interior-mobile-header-logo" />
      </>
    );
  }
}
